export const IntersectionIcon: React.FC = () => {
  return (
    <svg width='19' height='12' viewBox='0 0 19 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='5.99976' cy='5.99976' r='5.49976' stroke='white' />
      <circle cx='12.0017' cy='5.99976' r='5.49976' stroke='white' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.9951 10.7969C10.5136 9.91792 11.5351 8.27577 11.5351 6.39503C11.5351 4.51429 10.5136 2.87214 8.9951 1.99316C7.47661 2.87214 6.45508 4.51429 6.45508 6.39503C6.45508 8.27577 7.47662 9.91792 8.9951 10.7969Z'
        fill='white'
      />
    </svg>
  )
}
